(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ag-customer-trust"]) return;
  try {
    
  function initializeCustomerReviews() {
    document.querySelectorAll('[data-customer-reviews]').forEach(function (root) {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const track = root.querySelector('.ag-customer-reviews__track');
      const previous = root.querySelector('[data-review-prev]');
      const next = root.querySelector('[data-review-next]');
      const cards = Array.from(track.querySelectorAll('.ag-customer-review'));
      const count = root.querySelector('[data-review-count]');
      function update() {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        const visible = cards.filter(function (card) { return !card.hidden; });
        const bounds = track.getBoundingClientRect();
        const shown = visible.map(function (card, index) { return { rect: card.getBoundingClientRect(), index: index + 1 }; }).filter(function (item) { return item.rect.left < bounds.right - 24 && item.rect.right > bounds.left + 24; });
        count.textContent = shown.length ? shown[0].index + '-' + shown[shown.length - 1].index + ' / ' + visible.length : '0 / ' + visible.length;
      }
      function move(direction) {
        const card = cards.find(function (item) { return !item.hidden; });
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        const perPage = Math.max(1, Math.floor((track.clientWidth + parseFloat(getComputedStyle(track).columnGap)) / step + 0.01));
        track.scrollBy({ left: direction * step * perPage, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      previous.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    });
  }
  initializeCustomerReviews();
  document.addEventListener('shopify:section:load', initializeCustomerReviews);

  } catch(e) { console.error(e); }
})();
})();
